// Dependencies
import React, { FC, ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
// Core & Lab
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
// Icons
import Close from '@mui/icons-material/Close';
// Actions
import {
    loadStockRoomProduct, updateStockRoomProduct,
    updateStockRoomProductInfo
} from './redux/reducer';
// Types
import { format } from 'date-fns';
import { AppState } from '../../reducers';
// import { ROOM_PRODUCTS_MOCK } from './mocks/roomProductMock';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Checkbox, Popover } from '@mui/material';
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';
import { useShowError } from '../../functions/useShowError';
import { BOOKING_STATUS_RTADUCTION } from '../stockStatus/constant/bookingStatusTraduction';
// import { BookingStatus } from '../stockStatus/objects/bookingStatus';
import { RoomProduct } from '../stockStatus/objects/roomProduct';
// import { updateMultipleRoomProductService, updateRoomProductService } from '../stockStatus/services/updateRoomProduct';
// import { setFinished } from '../utils/finished/redux/actions';
// import { useRefreshStockStatusList } from './hooks/useRefreshStockStatus';


const AccordionSummary = styled((props: AccordionSummaryProps & { onToggleExpanded: any, product_index: number }) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} onClick={props.onToggleExpanded(props.product_index)} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const ChannelManagerStockStatusRoomProduct: FC = (): ReactElement | null => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const stock_room_product_info = useSelector((state: AppState) => state.channelManager.stock_room_product_info);
    const stock_room_products = useSelector((state: AppState) => state.channelManager.stock_room_products);
    const channel_manager = useSelector((state: AppState) => state.channelManager.channel_manager);
    const contract_selected = useSelector((state: AppState) => state.channelManager.contract_selected);
    const client_id = useSelector((state: AppState) => state.header.client_id);
    const [is_expanded, setIsExpanded] = useState<boolean[]>([]);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [room_product, setRoomProduct] = useState<null | RoomProduct>(null);
    const [room_products_edit_actions, setRoomProductsEditActions] = useState<boolean[]>([]);
    const showError = useShowError();
    // const refreshStockStatus = useRefreshStockStatusList();
    // const onEditRoomProductStatus = (room_product: RoomProduct) => (event: React.MouseEvent<HTMLButtonElement>) => {
    //     setRoomProduct(room_product);
    //     setAnchorEl(event.currentTarget);
    // };
    // const handleClose = () => {
    //     setAnchorEl(null);
    // };
    const open_booking_status = Boolean(anchorEl);
    const id = open_booking_status ? 'simple-popover' : undefined;
    // const stock_room_products = ROOM_PRODUCTS_MOCK;
    const onToggleRoomProducts = () => {
        dispatch(updateStockRoomProductInfo(null));
        dispatch(updateStockRoomProduct(null));
    };
    // const acceptRoomProduct = () => {
    //     if (room_product) {
    //         dispatch(setFinished(true));
    //         updateRoomProductService(Number(client_id), room_product, BookingStatus.CONFIRMED)
    //             .then(() => {
    //                 dispatch(loadStockRoomProduct());
    //                 dispatch(setFinished(false));
    //             })
    //             .catch((error) => {
    //                 showError(error);
    //                 dispatch(setFinished(false));
    //             });
    //     }
    //     handleClose();
    // };
    // const acceptRoomProducts = () => {
    //     if (stock_room_products) {
    //         dispatch(setFinished(true));
    //         const room_products_requests = room_products_edit_actions.reduce((acc, value, index) => {
    //             if (value)
    //                 acc.push(stock_room_products[index]);
    //             return acc;
    //         }, [] as RoomProduct[]);
    //         updateMultipleRoomProductService(Number(client_id), room_products_requests, BookingStatus.CONFIRMED)
    //             .then(() => {
    //                 dispatch(loadStockRoomProduct());
    //                 dispatch(setFinished(false));
    //             })
    //             .catch((error) => {
    //                 showError(error);
    //                 dispatch(setFinished(false));
    //             });
    //     }
    //     handleClose();
    // };
    // const onPendingRoomProduct = () => {
    //     if (room_product) {
    //         dispatch(setFinished(true));
    //         updateRoomProductService(Number(client_id), room_product, BookingStatus.PENDING)
    //             .then(() => {
    //                 dispatch(loadStockRoomProduct());
    //                 dispatch(setFinished(false));
    //             })
    //             .catch((error) => {
    //                 showError(error);
    //                 dispatch(setFinished(false));
    //             });
    //     }
    //     handleClose();
    // };
    // const onPendingRoomProducts = () => {
    //     if (stock_room_products) {
    //         dispatch(setFinished(true));
    //         const room_products_requests = room_products_edit_actions.reduce((acc, value, index) => {
    //             if (value) {
    //                 acc.push(stock_room_products[index]);
    //             }
    //             return acc;
    //         }, [] as RoomProduct[]);
    //         updateMultipleRoomProductService(Number(client_id), room_products_requests, BookingStatus.PENDING)
    //             .then(() => {
    //                 dispatch(loadStockRoomProduct());
    //                 dispatch(setFinished(false));
    //             })
    //             .catch((error) => {
    //                 showError(error);
    //                 dispatch(setFinished(false));
    //             });
    //     }
    //     handleClose();
    // };
    // const declineRoomProduct = () => {
    //     if (room_product) {
    //         dispatch(setFinished(true));
    //         updateRoomProductService(Number(client_id), room_product, BookingStatus.REFUSED)
    //             .then((response) => {
    //                 dispatch(loadStockRoomProduct());
    //                 dispatch(setFinished(false));
    //                 refreshStockStatus();
    //             })
    //             .catch((error) => {
    //                 showError(error);
    //                 dispatch(setFinished(false));
    //             });
    //     }
    //     handleClose();
    // };
    // const declineRoomProducts = () => {
    //     if (stock_room_products) {
    //         dispatch(setFinished(true));
    //         const room_products_requests = room_products_edit_actions.reduce((acc, value, index) => {
    //             if (value)
    //                 acc.push(stock_room_products[index]);
    //             return acc;
    //         }, [] as RoomProduct[]);
    //         updateMultipleRoomProductService(Number(client_id), room_products_requests, BookingStatus.REFUSED)
    //             .then(() => {
    //                 dispatch(loadStockRoomProduct());
    //                 dispatch(setFinished(false));
    //                 refreshStockStatus();
    //             })
    //             .catch((error) => {
    //                 showError(error);
    //                 dispatch(setFinished(false));
    //             });
    //     }
    //     handleClose();
    // };
    const onToggleExpanded = (product_index: number) => () => {
        setIsExpanded(expanded => expanded.map((expand, id) => id === product_index ? !expand : expand));
    };
    const onToggleRoomAction = (product_index: number) => {
        setRoomProductsEditActions(checked => checked.map((check, id) => id === product_index ? !check : check));
    };
    const selectAll = () => {
        if (!room_products_edit_actions.some(val => val))
            setRoomProductsEditActions(checked => checked.map(() => true));
        else
            setRoomProductsEditActions(checked => checked.map(() => false));
    };
    useEffect(() => {
        setIsExpanded(stock_room_products?.map(() => false) || []);
        setRoomProductsEditActions(stock_room_products?.map(() => false) || []);
    }, [stock_room_products]);
    return (
        <>
            {channel_manager && contract_selected && stock_room_product_info && stock_room_products ?
                <Dialog fullWidth open={!!stock_room_product_info && !!stock_room_products} onClose={onToggleRoomProducts} maxWidth={'md'}>
                    <AppBar component="nav" className={'ft-user-appBar'}>
                        <Toolbar>
                            <IconButton edge={'start'} color={'inherit'} onClick={onToggleRoomProducts}><Close /></IconButton>
                            <Typography variant={'h6'}>{t('shared.stock')} {` ( ${format(new Date(stock_room_product_info.real_stock.date), 'dd/MM/yyyy')} )`} :  {channel_manager.name} - {contract_selected.provider?.client?.name} - {contract_selected.name}</Typography>
                        </Toolbar>
                    </AppBar>
                    <Container className={'ft-container'} maxWidth={'xl'} sx={{ height: '100%', overflow: 'scroll' }}>
                        <Grid container>
                            <Checkbox
                                checked={!room_products_edit_actions.some(val => !val)}
                                indeterminate={room_products_edit_actions.some(val => val) !== !room_products_edit_actions.some(val => !val)}
                                onChange={selectAll}
                            />
                            {/* {room_products_edit_actions.some((val) => val) && <>
                                <Button onClick={acceptRoomProducts}>{t('shared.stock-status-confirm-room')}</Button>
                                <Button onClick={onPendingRoomProducts}>{t('shared.stock-status-wait-room')}</Button>
                                <Button onClick={declineRoomProducts}>{t('shared.decline')}</Button>
                            </>
                            } */}
                        </Grid>
                        {
                            stock_room_products && stock_room_products.length > 0 ?
                                stock_room_products.map((room_product, product_index) =>
                                    <Grid flexDirection={'row'} display={'flex'} key={`stock-status-room-product-${room_product.id}`}>
                                        <Checkbox
                                            checked={!!room_products_edit_actions[product_index]}
                                            onClick={() => {
                                                onToggleRoomAction(
                                                    product_index
                                                );
                                            }}
                                        />
                                        <Accordion sx={{ width: '100%' }} square expanded={!!is_expanded[product_index]}>
                                            <AccordionSummary className={'ft-user-title'} onToggleExpanded={onToggleExpanded} product_index={product_index}>
                                                <Grid container sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <Grid item onClick={onToggleExpanded(product_index)}>
                                                        <Typography>
                                                            {t('shared.sale')} N° {(room_product.booking_status.item_reference)}, {t('shared.folder')} N° {(room_product.trip.trip_reference)} : {
                                                                room_product.group_passenger.lead_traveler_info
                                                                    ? <>{room_product.group_passenger.lead_traveler_info.first_name} {room_product.group_passenger.lead_traveler_info.middle_name} {room_product.group_passenger.lead_traveler_info.last_name}</>
                                                                    : <> {t('manual-flight-folder.no-lead-traveler')} </>
                                                            }
                                                            {
                                                                room_product.trip.current_version?.for_user?.company ? <> ({room_product.trip.current_version?.for_user.company}) </> : <></>
                                                            }
                                                            {
                                                                room_product.start_date && room_product.end_date ? <> ({format(new Date(room_product.start_date), 'dd/MM/yyyy')} - {format(new Date(room_product.end_date), 'dd/MM/yyyy')}) </> : <></>
                                                            }

                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant='subtitle2' aria-describedby={id} >{t(`shared.${BOOKING_STATUS_RTADUCTION[room_product.booking_status.status_booking]}`)}</Typography>
                                                        {/* {
                                                            room_product.booking_status.status_booking === BookingStatus.WAITING
                                                                ? <Button variant="outlined" onClick={onEditRoomProductStatus(room_product)}>{t(`shared.${BOOKING_STATUS_RTADUCTION[room_product.booking_status.status_booking]}`)}</Button>
                                                                : <Typography variant='subtitle2' aria-describedby={id} >{t(`shared.${BOOKING_STATUS_RTADUCTION[room_product.booking_status.status_booking]}`)}</Typography>
                                                        } */}
                                                    </Grid>
                                                </Grid>

                                            </AccordionSummary>
                                            <AccordionDetails className={'ft-user-subContainer'}>
                                                <Grid container spacing={2}>

                                                    <Grid item container xs={12}>
                                                        <Grid item xs={12} >
                                                            <Typography variant='h6'>{t(`shared.traveler(s)`)} ({room_product.group_passenger.travelers_list.length || 0})</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} >
                                                            {
                                                                room_product.group_passenger.travelers_list && room_product.group_passenger.travelers_list.length > 0
                                                                    ? room_product.group_passenger.travelers_list.map((traveler, index) => <Typography variant='body2' key={`stock-status-room-product-traveler-${index}`}>{traveler.first_name} {traveler.middle_name} {traveler.last_name}</Typography>)
                                                                    : <Typography sx={{ color: 'text.secondary' }}> {t('shared.no-traveler')}</Typography>
                                                            }
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                )
                                : <Typography sx={{ color: 'text.secondary' }}> {t('shared.no-sale')}</Typography>
                        }

                        <Grid container spacing={2} justifyContent={'flex-end'}>
                            <Grid item>
                                <Button onClick={onToggleRoomProducts}>{t('shared.close')}</Button>
                            </Grid>
                        </Grid>
                    </Container>
                </Dialog> : null}
            {/* <Popover
                id={id}
                open={open_booking_status}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Grid container>
                    <Button variant='outlined' onClick={acceptRoomProduct}>{t('shared.stock-status-confirm-room')}</Button>
                    <Button variant='outlined' onClick={onPendingRoomProduct}>{t('shared.stock-status-wait-room')}</Button>
                    <Button variant='outlined' onClick={declineRoomProduct}>{t('shared.decline')}</Button>
                </Grid>
            </Popover> */}
        </>
    );
};



export default ChannelManagerStockStatusRoomProduct;